module.exports = __webpack_public_path__ + "media/country_flags/am-b76d7008.png";